import { render, staticRenderFns } from "./NewsflashJaPublished.vue?vue&type=template&id=698a03a7&scoped=true&"
import script from "./NewsflashJaPublished.vue?vue&type=script&lang=js&"
export * from "./NewsflashJaPublished.vue?vue&type=script&lang=js&"
import style0 from "./NewsflashJaPublished.vue?vue&type=style&index=0&id=698a03a7&prod&lang=scss&scoped=true&"
import style1 from "./NewsflashJaPublished.vue?vue&type=style&index=1&id=698a03a7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "698a03a7",
  null
  
)

export default component.exports